<style scoped>
    .contract-group-container{
        /*position: relative;*/
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
        /*margin-right: 5px;*/
    }
    .header{
        display: inline-block;
        vertical-align: middle;
        font-size: 24px;
    }
    .handler{
        margin-left: 10px;
    }
    .edit-container{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 20px 20px 120px 20px;
        overflow: auto;
        background: white;
        z-index: 999;
    }
    .edit-header{
        font-size: 18px;
        font-weight: bold;
    }
    .close-editor-btn{
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .edit-title{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .fill-info{
        padding-bottom: 10px;
        border-bottom: 1px solid #dddee1;
    }
    .fill-info-title{
        /**/
    }
    .fill-info-btn{
        color: #2d8cf6;
        text-decoration: underline;
        cursor: pointer;
    }
    table{
        border-collapse:collapse;
    }
    table tr{
        border-bottom: 1px solid #dddee1;
    }
    table th, table td{
        border-right: 1px solid #dddee1;
    }
    .payee-account-container{
        margin-top: 20px;
    }
    .payee-account-table{
        width: 100%;
        border: 1px solid #dddee1;
    }
    .payee-account-table td{
        padding: 10px;
        text-align: center;
    }
    .payee-account-col-1{
        width: 60px;
        font-size: 14px;
        font-weight: bold;
    }
    .payee-account-col-2{
        width: 70px;
    }
    .payee-account-handler{
        padding: 10px;
    }
    .edit-contract-container{
        margin-top: 20px;
    }
    .edit-contract-table{
        border: 1px solid #dddee1;
        width: 100%;
    }
    .edit-contract-table th{
        padding: 10px;
        text-align: center;
    }
    .edit-contract-table td{
        padding: 10px;
    }
    .edit-contract-col-1{
        width: 60px;
        text-align: center;
    }
    .edit-contract-col-7{
        min-width: 70px;
    }
    .td-price{
        text-align: right;
    }
    .td-handler{
        min-width: 70px;
        text-align: center;
    }
    .td-number{
        width: 100px;
        height: 24px;
        line-height: 24px;
        margin-top: -1px;
        vertical-align: top;
        padding: 0 7px;
        text-align: right;
        outline: 0;
        -moz-appearance: textfield;
        color: #666;
        border: 1px solid #dddee1;
        border-radius: 3px;
        transition: all .2s linear;
    }
    .price-line{
        white-space: nowrap;
    }
    .input-btn{
        cursor: pointer;
    }
    .input-btn:hover{
        color: #444;
    }
    .chinese-number{
        display: inline-block;
        width: 70px;
        text-align: right;
    }
    .cn-number{
        font-size: 1.1em;
        font-weight: bold;
        font-style: italic;
    }
    .contract-btn{
        display: inline-block;
        padding: 1px 5px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
    }
    .contract-btn:hover{
        background: #e5e5e5;
    }
    .select-customer-container{
        white-space: normal;
        margin-top: 5px;
    }
    .select-customer{
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
    }
    .select-customer:hover{
        background: #e5e5e5;
    }
    .select-payee{
        display: block;
        margin-right: 5px;
        margin-bottom: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
    }
    .select-payee-account, .select-contract-type{
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .select-payee-account:hover, .select-contract-type:hover{
        background: #e5e5e5;
    }
    .select-customer-disabled, .select-payee-account-disabled{
        background: #e5e5e5;
        color: #999;
        cursor: auto;
    }
    .select-customer-disabled:hover, .select-payee-account-disabled:hover{
        background: #e5e5e5;
    }
    .pop-tip-content{
        max-height: 200px;
    }
    .search-item{
        padding: 4px 8px;
        cursor: pointer;
        border: 1px solid #dddee1;
        border-radius: 6px;
        margin: 5px 0;
    }
    .search-item:hover{
        background: #f5f5f5;
    }
    .ivu-poptip{
        vertical-align: top;
    }
    .ivu-poptip .ivu-btn{
        position: relative;
        top: 1px;
    }
    .price-wrapper{
        display: inline-block;
        width: 255px;
    }
    .attachment{
        display: inline-block;
        margin: 0 3px;
        vertical-align: middle;
        text-decoration: underline;
        color: #2d8cf6;
        cursor: pointer;
    }
    .margin-a {
        margin: 5px;
    }
</style>
<template>
  <PageContain>
    <div class="contract-group-container">
      <div class="line text-center">
        <Select
          v-model="params.contract_type_id"
          class="margin-a"
          placeholder="合同类型"
          style="width: 150px"
          @on-change="doSearch"
        >
          <Option :value="0">
            所有合同类型
          </Option>
          <Option
            v-for="(ct,index) in (contract_types||[])"
                 
            :key="index"
            :value="ct.id"
          >
            {{ ct.sub_type }}({{ ct.type_code }})
          </Option>
        </Select>
        <Select
          v-model="params.company_id"
          class="margin-a"
          placeholder="公司"
          style="width: 120px"
          @on-change="doSearch"
        >
          <Option :value="0">
            所有公司
          </Option>
          <Option
            v-for="company in companies"
            :key="company.id"
            :value="company.id"
          >
            {{ company.short_name }}
          </Option>
        </Select>
        <Select
          v-if="teams.length"
          v-model="params.team_id"
          class="margin-a"
          placeholder="团队"
          style="width: 120px"
          @on-change="doSearch"
        >
          <Option
            v-for="(team,index) in select_teams"
            :key="index"
            :value="team.id"
          >
            {{ team.name }}
          </Option>
        </Select>
        <Select
          v-model.number="params.flow_node_id"
          class="margin-a"
          placeholder="选择节点"
          style="width: 120px"
          @on-change="doSearch"
        >
          <Option :value="0">
            所有节点
          </Option>
          <Option
            v-for="flow_node in flow_nodes"
            :key="flow_node.id"
            :value="flow_node.id"
          >
            {{ flow_node.name }}
          </Option>
        </Select>
        <Select
          v-model.number="params.user_flow_node_status"
          class="margin-a"
          placeholder="节点状态"
          style="width: 100px"
          @on-change="doSearch"
        >
          <Option :value="-1">
            所有状态
          </Option>
          <Option :value="0">
            进行中
          </Option>
          <Option :value="1">
            完成/通过
          </Option>
        </Select>
        <!-- todo -->
        <Select
          v-model="params.bill_generate_type"
          class="margin-a"
          style="width: 150px"
          clearable
          placeholder="账单生成方式"
          @on-change="changeBillGenerateType"
        >
          <Option
            v-for="item in bill_generate_type_lists"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </Option>
        </Select>
        <!-- bill_provider_types -->
        <Select
          v-if="params.bill_generate_type==='self_submit'"
          v-model="params.bill_provider"
          class="margin-a"
          placeholder="账单来源"
          style="width: 130px"
          clearable
          @on-change="doSearch"
        >
          <Option
            v-for="item in bill_provider_types"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </Option>
        </Select>
        <Select
          v-model="params.contract_status"
          class="margin-a"
          placeholder="合同状态"
          style="width: 120px"
          clearable
          @on-change="doSearch"
        >
          <Option value="normal">
            正常
          </Option>
          <Option value="closed">
            完结
          </Option>
          <Option value="deleted">
            废弃
          </Option>
        </Select>
        <Checkbox
          v-model="params.without_auto_generated"
          @on-change="doSearch()"
        >
          非个人虚拟合同
        </Checkbox>
      </div>
      <div class="line text-center">
        <span
          v-if="false"
          class="handler"
        >
          <Button
            type="primary"
            icon="md-add"
            @click="editContract(new_contract)"
          >添加</Button>
        </span>
        <Select
          v-model="params.order"
          class="margin-a"
          placeholder="选择排序方式"
          style="width: 150px"
          @on-change="doSearch"
        >
          <Option value="mid">
            按编号排序
          </Option>
          <Option value="node_created_at">
            按状态更新时间排序
          </Option>
        </Select>
        
        <div class="search-input">
          <i-input
            v-model="params.search"
            class="margin-a"
            placeholder="输入关键字搜索"
            @on-enter="doSearch()"
          />
        </div>
        <Ajaxbtn
          ref="searchBtn"
          class="margin-a"
          :url="get_contracts_path"
          :params="params"
          type="search"
          @before="beforeSearch"
          @done="handleContractData"
          @fail="handleContractFail"
          @finally="handleContractFinally"
        />

        <Button
          class="margin-a"
          icon="ios-barcode-outline"
          type="primary"
          @click="searchByBarCode"
        >
          扫码搜索
        </Button>
      </div>
      <div class="list-container">
        <PageContain :reserved-height="310">
          <VTable
            fixed-header
            :fixed-header-zindex="3"
            :loading="loading"
            :headers="contract_columns"
            :desserts="contracts"
            :td-style="contract_table_style"
          />
        </PageContain>
        <!-- <Backdrop v-show="loading" /> -->
        <div class="line">
          点击左侧箭头可查看详细信息
        </div>
      </div>

      <div
        v-show="page_info.total"
        class="line paginate-fix-bottom"
      >
        <Page
          show-total
          show-elevator
          :current="page_info.current"
          :total="page_info.total"
          :page-size="page_info.page_size"
          @on-change="pageChange"
        />
      </div>
      <EditModal
        ref="edit_modal"
        @next="next"
      />

      <EditNextModal 
        ref="edit_next_modal"
        @success="()=>{
          doSearch()
        }"
        @needTfModal="needTfModal"
      />
      <ContractEditor
        ref="guidang"
        :contract_types="contract_types"
        :contract_type_hash="contract_types_hash"
        @on-update="updateContract"
      /> 
      <ContractDetailPendingModal
        ref="smodal"
        @success="doSearch"
      />
    </div>
    <TfModal
      ref="tf_modal"
      contract-type="contract"
    />
  </PageContain>
</template>
<script route="/fin/contract">
  import {VAutocomplete} from 'vuetify/lib'
  import { getsafe } from '@/libs/util.js'
  import {bill_generate_type_lists, bill_provider_types} from '@/views/contract/libs/fields.js'
  import GoPayment from '@/views/business/components/GoPayment.jsx'
  import ContractUid from './components/contract_uid';
  import ContractDetailPendingModal from '@/views/business/components/ContractDetailPendingModal.jsx'
  import ContractExpand from './components/contract_expand';
  import ContractDetail from '../components/viewer/components/contract';
  import ContractEditor from '../contract/components/contract_editor';
  import UserFlowBase from '../components/flow/user_flow_base';
  import FileUploader from '../components/file/uploader';
  import {mapGetters} from "vuex";
  import VTable from '@/vuetify_custom/v-table/v3'
  import Vue from 'vue';
  import Vuetify from "vuetify"; 
  import PageContain from '@/views/components/PageContain.vue'
  import Options from '../mine/options.vue';
  import EditNextModal from '@/views/business/components/EditNextModal.jsx'
  import EditModal from '@/views/business/components/EditModal.jsx'
  import TfModal from '@/views/business/components/TfModal.jsx'
  import VPopV from '@/views/business/components/v-pop-v.vue'
  import { getContractDetailApi, contractCheckAddPaymentApi } from '@/views/business/service.js'
  export default {
    components: { ContractUid, ContractExpand, ContractDetail, ContractEditor, EditNextModal, UserFlowBase, FileUploader, Options, VTable, ContractDetailPendingModal, EditModal, PageContain, TfModal },
    data() {
      this.goPayment = null
      return {
        //get_contracts_path: Util.api.query_contract,
        get_contracts_path: this.$util.api.es_query_contract,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          contract_status:'',
          per_page: 10,
          page: 1,
          search: '',
          team_id: 0,
          company_id: 0,
          contract_type_id: 0,
          flow_node_id: 0,
          user_flow_node_status: -1,
          order: 'mid',
          contract_status: '',
          bill_generate_type: null,
          bill_provider: null,
          without_auto_generated: true
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        contracts: [],
        contract_columns: [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            expand:true,
            width: 50,
            fixed: 'left',
            z_index:1,
            renderv: (h, _, params) => {
              /*return h(ContractExpand, {
                                props: {
                                    id: params.row.id
                                }
                            })*/
              return h(ContractDetail, {
                props: {
                  model_id: params.id,
                  showTfAdd:true
                },
                on: {
                  addTf:(val, call) => {
                    this.$refs.tf_modal.edit(val, {
                      closeCall:call
                    })
                  }
                }
              })
            }
          },
          {
            text: '编号',
            value: 'uid',
            width: 200,
            renderv: (h, _, row) => {
              // const row = params.row;
              return h(ContractUid, {
                props: {
                  contract: row
                }
              });
            }
          },
          {
            text: '名称',
            value: 'name',
            width: 200,
            renderv: (h, _, row) => {
              // const row = params.row;
              const ret = [];
              ret.push(h('div', row.name));
              if (row.contract_type_id) {
                ret.push(h('div', `[${this.contract_types_hash.getSubType(row.contract_type_id)}]`));
              }
              if (row.bill_type === 'OutSourcing') {
                ret.push(h('div', '[委外订单]'));
              }
              return h('div', ret);
            }
          },
          {
            text: '公司-团队',
            width: 160,
            renderv: (h, _, row) => {
              let company = '未设置';
              if (this.companies_hash[row.company_id]) {
                company = this.companies_hash[row.company_id].short_name;
              }
              let team = '未设置';
              if (this.teams_hash[row.team_id]) {
                team = this.teams_hash[row.team_id].name;
              }
              const ret = [];
              ret.push(h('div', {
                'class':{
                  'text-bold': true
                },
              }, company));
              ret.push(h('div', team));
              return h('div', ret);
            }
          },
          {
            text: '申请人',
            width: 80,
            key: 'apply_user',
            renderv: (h, _, row) => {
              return <CustomerName id={ row.apply_user_id } />
            }
          },
          {
            text: '对方公司',
            width: 160,
            value: 'payee_company',
            renderv: (h, _, row) => {
              const is_multi_payee = getsafe(row, 'multi_payee', false)
              const ret = [];
              ret.push(h('span', row.payee_company));
              if (is_multi_payee) {
                ret.push(h('span', {class:'color-error', style:'margin-left:5px'}, '[MV]'))
              }
              return h('div', ret);
            }
          },
          {
            text: '合同总价',
            align: 'end',
            width: 110,
            value: 'total_price',
            type: 'money_field',
            default_value: '-'
            // renderv: (h, _, row) => {
            //   const ret = [];
            //   ret.push(h('span', [undefined, null, ''].includes(row.total_price) ? '-' : formattingNumber(row.total_price, 2)));
            //   return h('div', {
            //     style:{
            //       margin: '0 10px 0 0'
            //     },
            //     'class': {
            //       // 'text-left': true
            //     }
            //   }, ret);
            // }
          },
          {
            text: '状态',
            width: 125,
            value: 'status',
            align: 'center',
            renderv: (h, _, row) => {
             
              const user_flow = row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  }
                })
              } else {
                return h('div', '-');
              }
            }
          },
          {
            text: '操作',
            width: 75,
            align: 'center',
            z_index:1,
            fixed: 'right',
            renderv: (h, _, row, index) => {
              return h('Dropdown', {
                props: {
                  trigger: 'click',
                  placement: 'left'
                },
                on: {
                  'on-click': (event_name) => {
                    this.handleContractEvent(event_name, row, index);
                  }
                }
              }, [
                h('div', {
                  class: {
                    link: true
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-down'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, [
                  h('DropdownItem', {
                    props:{name: 'edit'}
                  }, '编辑'),
                  h('DropdownItem', {
                    props:{name: 'payment'}
                  }, '申请付款'),
                  h('DropdownItem', {
                    props:{name: 'generate_virtual_child'}
                  }, [
                    h('span', {}, '生成虚拟子合同'),
                    h(VPopV)
                  ]),
                  h('DropdownItem', {
                    props:{name: 'generate_bill'}
                  }, '生成账单'),
                  h('DropdownItem', {
                    props:{name: 'consume_plan'}
                  }, '生成消耗单'),
                  h('DropdownItem', {
                    props:{name: 'store-file'}
                  }, '归档'),
                  h('DropdownItem', {
                    props:{name: 'close'}
                  }, '完结'),
                  h('DropdownItem', {
                    props:{name: 'is_not_close'}
                  }, '未完结'),
                  /*h('DropdownItem', {
                                        props:{name: 'print'}
                                    }, '打印'),
                                    h('DropdownItem', {
                                        props:{name: 'copy'}
                                    }, '复制一份'),
                                    h('DropdownItem', {
                                        props:{name: 'edit_desc'}
                                    }, '设置备注'),*/
                  h('DropdownItem', {
                    props:{name: 'sync-to-kingdee', divided: true}
                  }, '同步至金蝶'),
                  h('DropdownItem', {
                    props:{name: 'delete'}
                  }, '废弃'),
                ])
              ]);
            }
          }
        ],
        contract_table_style: {
          "font-size": "12px",
          "padding": "5px 16px"
        },
        edit_contract: {},
        //  contract_types: [],
        //  contract_type_hash: {},

        flow_nodes: [],

      }
    },
    computed: {
      bill_generate_type_lists:() => {
        return bill_generate_type_lists.slice(1)
      },
      bill_provider_types: () => {
        return bill_provider_types
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      select_teams() {
        const teams = [];
        teams.push({id: 0, name: '所有团队'});
        this.teams.forEach((team) => {
          teams.push(team);
        });
        return teams;
      },
      search_contract_type_result() {
        const ret = [];
        const search = this.search_contract_type_text;
        this.contract_types.forEach((type) => {
          if (search) {
            if (type.name.indexOf(search) > -1) {
              ret.push(type);
            }
          } else {
            ret.push(type);
          }
        });
        return ret;
      },
      ...mapGetters({
        contract_types: 'async/contract_types',
        contract_types_hash: 'async/contract_types_hash',
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    created() {
      this.init();
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      needTfModal(params, out_params) {
        this.$refs.tf_modal.edit(params, out_params)
      },
      notClose(data) {
        this.$refs.smodal.edit({...data, type:1})
      },
      next(data) {
        this.$refs.edit_next_modal.edit(data, {
          need_draft :false
        })
      },
      // 生成虚拟子合同
      generateVirtualChild(p) { 
        let text = ''
        if (p.is_virtual) {
          text = '虚拟合同不能生成虚拟子合同！'
        }
        if (p.is_closed && !text) {
          text = '已完结的合同不能生成虚拟子合同！'
        }
        if (text) {
          this.$vModal.warning({
            title:'提示',
            content: text
          })
          return 
        }
        //  console.log('EditModal', EditModal.methods.getVirtualContractChildData)
        EditModal.methods.getVirtualContractChildData(p).then(({params, contract}) => {
          // 只有支出类&非存货类才能生成虚拟子合同
          if (params.contract_sz_type === 'expense' && params.contract_type_bread_id === 'stockless') {
            const _this = this
            let company = null
            this.$vModal.confirm({
              title: '提示',
              loading: true,
              render:(h) => {
                return h('div', {}, [h(VAutocomplete, {
                  props: {
                    label: '选择付款公司',
                    items:_this.companies,
                    'item-text': 'short_name',
                    'item-value': 'id'
                  },
                  on: {
                    change:(val) => {
                      company = _this.companies_hash[val]
                    }
                  }
                })])
              },
              onOk:({destroy, stopLoading}) => {
                if (!company) {
                  this.$Message.error('付款公司必选！')
                  stopLoading()
                  return
                }
                destroy()
                params.company_id = company.id
                this.$refs.edit_next_modal.handleFromMainChild({params, contract})
              }
            })

          } else {
            this.$vModal.warning({
              title:'提示',
              content: '支出类非存货类合同才能生成虚拟子合同！'
            })
          }
       
        })
      },
      changeBillGenerateType(data) {
        if (data !== 'self_submit') {
          this.params.bill_provider = null
        }
        this.doSearch()
      },
      init() {
        //  this.getContractTypes();
        this.getFlowInfo();
      },
      // getContractTypes() {
      //   Util.ajax.get(Util.api.get_contract_types).then((response) => {
      //     return response.data;
      //   }).then((res) => {
      //     if (res.code === 1) {
      //       const data = res.data;
      //       this.handleContractTypes(data);
      //     } else {
      //       this.$Modal.error({
      //         title: '错误',
      //         content: res.msg
      //       });
      //     }
      //   }).catch((e) => {
      //     console.log(e);
      //   });
      // },
      getFlowInfo() {
        Util.ajax.get(Util.api.get_flow_by_link_model, {
          params: {
            link_model: 'Contract'
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.nodes.forEach((node) => {
              this.flow_nodes.push(node);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      // handleContractTypes(contract_types) {
      //   contract_types.forEach((contract_type) => {
      //     /*if(contract_type.parent_id){
      //                   contract_type.name = this.contract_type_hash[contract_type.parent_id].name + '-' + contract_type.name;
      //               }*/
      //     this.contract_type_hash[contract_type.id] = contract_type;
      //     if (contract_type.contract_types.length) {
      //       contract_type.children = contract_type.contract_types;
      //       this.handleContractTypes(contract_type.contract_types);
      //     }
      //     this.contract_types.push(contract_type);
      //   });
      // },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      doSearch() {
        this.params.page = 1;
        this.$refs.searchBtn.doAjax();
      },
      handleContractData(data) {
        this.contracts = [];
        data.contracts.forEach((contract) => {
          this.contracts.push(contract);
        });
        if (data.contracts.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleContractFail(e) {
        this.$Modal.error({title: '错误', content: e.message});
      },
      handleContractFinally() {
        this.loading = false;
      },
      handleContractEvent(event_name, contract, index) {
        console.log(event_name);
        switch (event_name) {
        case 'edit':
          this.editContract(contract);
          break;
        case 'payment':
          this.editContractExpenseGroup(contract);
          break;
        case 'store-file':
          this.storeContractFile(contract);
          break;
        case 'close':
          this.closeContract(contract);
          break;
        case 'print':
          this.printContract(contract);
          break;
        case 'copy':
          this.copyContract(contract);
          break;
        case 'delete':
          this.deleteContract(contract);
          break;
        case 'edit_desc':
          this.editDesc(contract);
          break;
        case 'sync-to-kingdee':
          this.syncToKingdee(contract);
          break;
        case 'generate_bill': 
          this.generateBill(contract)
          break;
        case 'consume_plan':
          this.generateConsumePlan(contract)
          break;
        case 'generate_virtual_child': 
          this.generateVirtualChild(contract);
          break;
        case 'is_not_close':
          this.notClose(contract);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      // 生成账单
      generateBill(contract) {
        localStorage.setItem('contract_generate_bill', JSON.stringify(contract));
        window.open('/fin/expense_group_bill', '_blank');
      },
      generateConsumePlan(contract) {
        localStorage.setItem('contract_generate_consume_plan', JSON.stringify(contract));
        window.open('/fin/consumption_plan', '_blank');
      },
      closeContract(contract) {
        let content = `<p>${contract.uid} - ${contract.name}</p>`;
        content += `<p>你确定该合同已完结了吗?</p>`;
        this.$Modal.confirm({
          title: '将合同设置为完结状态',
          content: content,
          onOk: () => {
            Util.ajax.post(Util.api.close_contract, {
              id: contract.id,
              is_finish: true
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                contract.is_closed = true;
                this.$Message.success('设置成功!');
              } else {
                setTimeout(() => {
                  this.$Modal.error({title: '提示', content: res.msg});
                }, 600);
              }
            }).catch((e) => {
              setTimeout(() => {
                this.$Modal.error({title: '提示', content: e.message});
              }, 600);
            });
          }
        });
      },
      storeContractFile(contract) {
        if (contract.status === 'stamped' || contract.status === 'archived') {
          this.$refs.guidang.storeFile(contract);
          return 
        }
        this.$vModal.warning({
          title: '提示',
          content: '请先完成 [法务盖章] 节点，再进行合同归档操作。'
        })
      },
      editContract(contract) {
        getContractDetailApi({id:contract.id}).then(res => {
          this.$refs.edit_modal.edit(res.contract)
          // const params = handleEditData(res.contract)
          // this.$refs.editor.edit(params);
        })
        
        // this.$refs.editor.edit(contract);
      },
      printContract(contract) {
        this.$refs.printer.print(contract);
      },
      copyContract(contract) {
        const new_contract = Util.clone(contract);
        delete new_contract.id;
        delete new_contract.uid;
        new_contract.fill_user_id = this.cur_customer.id;
        new_contract.fill_user = this.cur_customer.account;
        new_contract.status = 0;
        new_contract.contracts.forEach((contract) => {
          delete contract.id;
        });
        this.editContract(new_contract);
      },
      deleteContract(contract) {
        let del_reason = '';
        this.$Modal.confirm({
          title: '提示',
          render: (h) => {
            return h('div', [
              h('div', {
                class: {
                  'line': true,
                  'color-error': true
                }
              }, `你确定要废弃 ${contract.name} 吗?`),
              h('Input', {
                props: {
                  value: del_reason,
                  type: 'textarea',
                  maxlength: 200,
                  autofocus: true,
                  placeholder: '请输入废弃的原因'
                },
                on: {
                  input: (val) => {
                    del_reason = val;
                  }
                }
              })
            ]);
          },
          onOk: () => {
            if (!del_reason.trim()) {
              this.$Message.error('请输入废弃的原因?');
              setTimeout(() => {
                this.deleteContract(contract);
              }, 500);
              return;
            }
            this.$util.ajax.post(this.$util.api.delete_contract, {
              id: contract.id,
              del_reason: del_reason
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                contract.del = true;
                this.$Message.success('废弃成功!');
              } else {
                this.$Modal.error({title: '提示', content: data.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        })
      },
      syncToKingdee(contract) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确定要同步至金蝶吗?',
          onOk: () => {
            this.$util.ajax.post(this.$util.api.contract_sync_to_kingdee, {
              id: contract.id
            }).then((response) => {
              return response.data;
            }).then((res) => {
              setTimeout(() => {
                if (res.code === 1) {
                  const ks = res.data.kingdee_sync;
                  if (ks.status === 1) {
                    this.$Message.success('同步成功');
                  } else {
                    this.$Modal.error({title: '同步失败', content: ks.result});
                  }
                } else {
                  this.$Modal.error({title: '同步失败', content: res.msg});
                }
              }, 600);
            }).catch((e) => {
              setTimeout(() => {
                this.$Modal.error({title: '同步失败', content: e.message});
              }, 600);
            });
          }
        });
      },
      // getContractType(id) {
      //   return this.contract_type_hash[id] || {};
      // },
      // getContractTypeName(id) {
      //   const type = this.contract_type_hash[id];
      //   return type ? type.name : '-';
      // },
      updateContract(contract) {
        if (contract.user_flow) {
          Util.insertOrUpdateArrayItem(this.contracts, contract, true);
        } else {
          this.doSearch();
        }
      },
      searchByBarCode() {
        eventHub.$emit('show-qr-scaner', (data) => {
          this.params.search = data;
          this.doSearch();
          setTimeout(() => {
            this.params.search = '';
          }, 100);
        });
      },
      editContractExpenseGroup(contract) {
        contractCheckAddPaymentApi({
          id: contract.id
        }).then(res => {
          if (res.can_add_payment) {
            localStorage.setItem('contract_id_fk', JSON.stringify(contract));
            window.open('/mine/expense_group_company', '_blank');
            return 
          }
          if (res.e_file_audit_allow) {
            this.$vModal.confirm({
              title: '提示',
              width:500,
              // content: tx,
              okText: '已经取得电子文件并知悉上述事项，需付款',
              render:(h) => {
                return h('div', {}, [
                  h('div', '该合同还未完成法务归档节点，若仍需付款，需上传电子文件以及补充事项理由，审核通过后可以申请付款～'),
                  h('div', 'ps：本付款属特批流程，需经过项目组负责人审批通过。')
                ])
              },
              onOk:() => {
                if (!this.goPayment) {
                  this.goPayment = new Vue({
                    vuetify: new Vuetify(),
                    store: this.$store,
                    render:(h) => {
                      return h(GoPayment, {
                        ref: 'c',
                        on:{
                          success:() => {
                            setTimeout(() => {
                              this.$refs.searchBtn.doAjax()
                            }, 300)
                          }
                        }
                      }) 
                    }
                  })
                  this.goPayment.$mount()
                }
                this.goPayment.$refs.c.edit(contract)
              }
            })
            return 
          }
          this.$vModal.warning({
            title: '提示',
            content: res.message
          })
        })
      },
    }
  }
</script>
